<div
  lpDropTarget
  [dropPivot]="pivot()"
  (draggableAdded)="onAdded($event)"
  (draggableRemoved)="onRemoved($event)"
  style="position: relative; width: 100%; height: 100%"
></div>
